import React from 'react';
import type { ScreenerSection } from '../types/screener';
import ScreenerQuestionItem from './ScreenerQuestionItem';

interface ScreenerSectionsProps {
  sections: ScreenerSection[];
  templateId: number | string;
  selectedAnswers: Record<string, string>;
  onAnswerChange: (answerKey: string, value: string) => void;
}

const ScreenerSections: React.FC<ScreenerSectionsProps> = ({
  sections,
  templateId,
  selectedAnswers,
  onAnswerChange,
}) => {
  return (
    <>
      {sections.map((section, sectionIndex) => {
        const sectionHeader = section.headertext || section.sectionname;
        return (
        <div key={`section-${sectionIndex}-${sectionHeader || 'no-header'}`} className="flex flex-col gap-6">
          {sectionHeader && (
            <div className="text-lg font-medium text-[#1C1C1C]">{sectionHeader}</div>
          )}
          <div className="flex flex-col gap-4">
            {section.questionlist.map((q, qIndex) => {
              const answerKey = `${templateId}_${sectionIndex}_${qIndex}`;
              return (
                <ScreenerQuestionItem
                  key={q.questionid}
                  question={q}
                  answerKey={answerKey}
                  selectedAnswer={selectedAnswers[answerKey]}
                  onAnswerChange={onAnswerChange}
                />
              );
            })}
          </div>
        </div>
        );
      })}
    </>
  );
};

export default ScreenerSections;
